import React from 'react';

import { useCustomValuesIn } from '@helpers/hooks/pages/dashboard/customValues/useCustomValuesIn';
import Header from './Header';
import Body from './Body';

import * as S from './styles';

const EditCustomValueSidemodal: React.FC = () => {
  const {
    isEditCustomValueSidemodalOpen,
    handleEditCustomValueSidemodalOpen,
  } = useCustomValuesIn();

  return (
    <>
      {isEditCustomValueSidemodalOpen ? (
        <S.Sidemodal
          isOpen={isEditCustomValueSidemodalOpen}
          toggle={handleEditCustomValueSidemodalOpen}
        >
          <Header />

          <Body />
        </S.Sidemodal>
      ) : (
        <></>
      )}
    </>
  );
};

export default EditCustomValueSidemodal;
